const Label = ({ children }) => (
  <label htmlFor="driver-type" className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-400">
    {children}
  </label>
);

export default Label;